"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M20.363 17.994V2.352H8.631l1.408 1.877h8.447v11.263l1.877 2.502z\" fill=\"#000\"></path><path d=\"M15.67 11.737h.94V9.86h-2.347l1.408 1.877zM12.855 7.983h3.754V6.106h-5.162l1.408 1.877zM4.802 1L3 2.352 5.346 5.48v15.643h11.732L18.486 23l1.802-1.352L4.802 1zm10.869 18.246H7.224V7.983l8.447 11.263z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;